import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { HOST_API } from '../../../config/hosts';

const Payments = () => {
  // verificar token
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [sessionData, setSessionData] = useState(null);

  useEffect(() => {
    if (sessionId) {
      fetch(`${HOST_API}/v1/payments/session/${sessionId}`)
        .then((res) => res.json())
        .then((data) => setSessionData(data));
    }
  }, [sessionId]);

  return sessionData && sessionData.status === 'paid' ? (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="500px"
    >
      {console.log(sessionData)}
      <Paper
        elevation={3}
        sx={{
          padding: '20px',
          borderRadius: '12px',
          textAlign: 'center',
          maxWidth: '700px',
          width: '100%',
        }}
      >
        <CheckCircleIcon sx={{ color: '#83d84d', fontSize: '60px', mb: 2 }} />
        <Typography variant="h4" component="h2" color="#83d84d" gutterBottom fontSize={26}>
          Parabéns!
        </Typography>
        <Typography variant="body1" color="#f1f1f1" gutterBottom fontSize={20}>
          Você adquiriu novas consultas do REDSCORE na Reduto Capital.
        </Typography>
        <Box mt={2}>
          <Typography variant="body2" color="#83d84d" fontSize={18}>
            Para mais informações, acesse nosso site.
          </Typography>
          <Typography variant="body2" color="#83d84d" fontSize={18}>
            Em caso de dúvidas, entre em contato com nosso suporte.
          </Typography>
        </Box>
        <Box mt={2} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            sx={{ mr: 1 }}
            onClick={() => (window.location.href = "/app/dashboard")}
          >
            Ir para o Dashboard
          </Button>
        </Box>
      </Paper>
    </Box>
  ) : (
    (window.location.href = "/app/dashboard")
  );
};
export default Payments;
